import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon as OriginalFontAwesomeIcon, } from "@fortawesome/react-fontawesome";
export const FontAwesomeIcon = ({ className = "", ...rest }) => (_jsx(OriginalFontAwesomeIcon, { className: className, ...rest }));
//# sourceMappingURL=FontAwesomeIcon.js.map